export enum StateOfGermany {
  BADEN_WUERTTEMBERG = 'BW',
  BAVARIA = 'BY',
  BERLIN = 'BE',
  BRANDENBURG = 'BB',
  BREMEN = 'HB',
  HAMBURG = 'HH',
  HESSE = 'HE',
  MECKLENBURG_VORPOMMERN = 'MV',
  LOWER_SAXONY = 'NI',
  NORTH_RHINE_WESTPHALIA = 'NW',
  RHINELAND_PALATINATE = 'RP',
  SAARLAND = 'SL',
  SAXONY = 'SN',
  SAXONY_ANHALT = 'ST',
  SCHLESWIG_HOLSTEIN = 'SH',
  THURINGIA = 'TH'
}
